<div class="object-details-text-content">
  <div class="object-details-text-content__item-wrapper" *ngFor="let text of texts; index as idx">
    <div class="object-details-text-content__content" [ngClass]="{ 'object-details-text-content__content--full' : text.isFull }" [innerHTML]="text.text">

    </div>
    <div class="object-details-text-content__read-more" *ngIf="!text.isFull" (click)="showMore(idx)">{{ "GENERAL.READ_MORE" | translate }}</div>
  </div>

</div>
